<template>
  <div class="ppt-world">
    <Resource
      :src="getFeUrl('/youyan-platform/png/shandong/pc-bg-6.png')"
      :transform-resource="transformImage"
      class="w-full"
      style="object-fit: inherit !important"
    />
    <div class="bottom">
      <div v-if="!isNamed" class="submit" @click="onSignUp">
        点击报名 <iconpark-icon name="arrowright" size="26"></iconpark-icon>
      </div>
      <div v-else class="preview" @click="open">
        查看我的参赛信息
        <iconpark-icon name="arrowright" size="26"></iconpark-icon>
      </div>
    </div>
    <OrderModal
      ref="modalRef"
      :width="408"
      :height="559"
      :icon="!isNamed"
      :title="isNamed ? '查看我的参赛信息' : '报名成功'"
      @close="onClose"
    >
      <template #content>
        <div class="order-content">
          <div class="z-10 relative">
            <div class="code">
              <div class="text-[15px] text-font-80">我的参赛码</div>
              <a-divider type="vertical"></a-divider>
              <div class="text-[16px] font-bold flex-1 text-center">
                {{ activeCode }}
              </div>
            </div>
            <div class="line"></div>
            <div
              class="mt-[23px] relative text-[18px] font-bold flex flex-col items-center"
            >
              <div class="text-bg">
                <div class="z-10 relative text-[22px]">扫描下方二维码进群</div>
                <div class="line-bg"></div>
              </div>
              <div class="text-[18px] leading-[30px]">获取活动参与信息</div>
              <div class="mt-[17px]">
                <Resource
                  :src="codeUrl"
                  class="w-[250px] h-[250px]"
                  :transform-resource="transformImage"
                ></Resource>
              </div>
            </div>
          </div>
        </div>
      </template>
    </OrderModal>
  </div>
</template>

<script lang="ts" setup>
import OrderModal from './components/modal.vue'
import {
  reqGetApply,
  reqPostApply,
  reqPostLandingPageVisit,
  type IChannel,
} from '@/api'
import { SESSION_SHANDONG } from '@/constants/config'
import { ACTIVITY_RANDOM_TYPE } from '~/constants'
import { PageKey } from '~/constants/page'

const props = defineProps<{
  qrcodeUrl?: string
  channelList: IChannel[]
}>()
const userInfo = useUserInfo()
const router = useRouter()
const route = useRoute()
const isNamed = ref(false)
const codeUrl = ref(props.qrcodeUrl)
let href = location.href

const modalRef = ref()
const activeCode = ref('')

const pptHref = localGetItem(SESSION_SHANDONG)

const open = () => {
  modalRef.value.toggle?.()
}

const qSearch = () => {
  if (!pptHref) {
    return null
  }

  const url = new URL(pptHref)
  const params: any = new URLSearchParams(url.search.slice(1))

  return params
}

const qSearchParams = qSearch()

const source = computed(
  () => (qSearchParams && qSearchParams.get('pcode')) || route.query.pcode
)
const immediateOpen = computed(
  () => (qSearchParams && qSearchParams.get('open')) || route.query.open
)

const onSignUp = async () => {
  if (!href.includes('open=1')) {
    const querySearch = href.includes('?') ? '&open=1' : '?open=1'
    href += querySearch
  }
  if (!pptHref) {
    localSetItem(SESSION_SHANDONG, href)
  }

  if (!userInfo.value) {
    goLogin({
      redirect: encodeURIComponent(href || pptHref),
    })
    return
  }

  const res = await reqPostApply({
    channel_code: source.value || '',
    activity_random_id: ACTIVITY_RANDOM_TYPE.SHANDONG_5G,
  })
  if (!res.code) {
    const defaultYouyan = props.channelList?.find(
      (v) => v.code === '0'
    )?.pc_link
    codeUrl.value =
      props.channelList?.find((v) => v.id === res.data?.channel_id)?.pc_link ||
      defaultYouyan
    localSetItem(SESSION_SHANDONG, null)
    activeCode.value = res.data.code
    open()
  }
}

const onClose = () => {
  isNamed.value = true
}

if (userInfo.value?.user_id) {
  await reqPostLandingPageVisit({
    channel_code: source.value,
    activity_random_id: ACTIVITY_RANDOM_TYPE.SHANDONG_5G,
  })
  const res = await reqGetApply(ACTIVITY_RANDOM_TYPE.SHANDONG_5G)
  const data = res.data?.length ? res.data[0] : null
  activeCode.value = data?.code || ''
  isNamed.value = !!data?.code
  const defaultYouyan = props.channelList?.find((v) => v.code === '0')?.pc_link
  codeUrl.value =
    props.channelList?.find((v) => v.id === data?.channel_id)?.pc_link ||
    defaultYouyan
  if (immediateOpen.value && !isNamed.value) {
    onSignUp()
  }
}

watch(userInfo, async () => {
  const res = await reqGetApply(ACTIVITY_RANDOM_TYPE.SHANDONG_5G)
  const data = res.data?.length ? res.data[0] : null
  activeCode.value = data?.code || ''
  isNamed.value = !!data?.code
  const defaultYouyan = props.channelList?.find((v) => v.code === '0')?.pc_link
  codeUrl.value =
    props.channelList?.find((v) => v.id === data?.channel_id)?.pc_link ||
    defaultYouyan
})

onBeforeUnmount(() => {
  if (!pptHref) {
    localSetItem(SESSION_SHANDONG, href)
  }
})
</script>

<style lang="scss" scoped>
.ppt-world {
  @apply relative min-w-[1200px];
  .host-shadow {
    background: linear-gradient(
      180deg,
      rgba(249, 244, 255, 0.95) 0%,
      #ffffff 100%
    );
    box-shadow: 0px 5px 32px 0px rgba(13, 3, 212, 0.08);
    border-radius: 39px;
    backdrop-filter: blur(6px);
  }
  .bottom {
    @apply fixed bottom-[0px] h-[212px] w-full text-white flex-y-center justify-center;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      #ffffff 100%
    );
    .submit {
      @apply w-[574px] h-[67px] rounded-[34px] flex-y-center justify-center text-[24px] font-bold cursor-pointer;
      background: linear-gradient(
        180deg,
        #ff7676 0%,
        #f47350 37%,
        #f04e23 100%
      );
      &:hover {
        background: #eb4215;
      }
    }
    .preview {
      @apply w-[574px] h-[67px] rounded-[34px] flex-y-center justify-center text-[24px] font-bold cursor-pointer;
      background: linear-gradient(180deg, #ffbd66 0%, #ff8830 100%);
      &:hover {
        background: #ff7d1f;
      }
    }
  }
}
.order-content {
  @apply p-[20px_35px] rounded-[20px] relative;
  z-index: 10;
  box-shadow: 0px 2px 12px 0px rgba(222, 222, 255, 0.4);
  &::before,
  &::after {
    z-index: 1;
    content: ' ';
    position: absolute;
    top: 0;
    width: 51%;
    height: 100%;
  }

  &::before {
    left: 0;
    background-image: radial-gradient(
      circle 10px at left 105px,
      transparent 10px,
      #ffffff 50%
    );
    border-radius: 12px 0 0 12px;
  }
  &::after {
    right: 0;
    background-image: radial-gradient(
      circle 10px at right 105px,
      transparent 10px,
      #ffffff 50%
    );
    border-radius: 0px 12px 12px 0;
  }

  .code {
    @apply bg-back-2  rounded-[11px] flex-y-center p-[15px_23px];
  }
  .line {
    @apply mt-[26px] relative;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to right,
      #ffd2af 0%,
      #ffd2af 50%,
      transparent 50%
    );
    background-size: 10px 1px;
    background-repeat: repeat-x;
  }
  .text-bg {
    @apply relative;
    .line-bg {
      z-index: 1;
      position: absolute;
      bottom: 0;
      left: 0;
      height: 10px;
      width: 100%;
      background: linear-gradient(180deg, #ffdbc8 0%, #fff8e6 100%);
    }
  }
}
</style>
